// import { materialize } from "rxjs/operator/materialize";

export const API: any = {

    // Urls para desarrollo

    //'url': 'http://25.86.12.90:8000/api/',
    //'fase1': 'http://25.86.12.90:8000/uploads/archivosClientes/fase1/',
    //'fase2': 'http://25.86.12.90:8000/uploads/archivosClientes/fase2/',
    //'contratos': 'http://25.86.12.90:8000/uploads/archivosClientes/contratos/',
    //'imagenesTickets': 'http://25.86.12.90:8000/uploads/imgTickets/',
    //'imgComentariosTickets': 'http:25.86.12.90:8000/uploads/imgComentariosTickets/',
    //'imagenesPerfil': 'http://25.86.12.90:8000/uploads/imagenesPerfil/',
    //'notificaciones': 'http://sm8-betasoft.ddns.net:3000',
//
    // Urls para produccion

     'url': 'https://software.sm8.com.mx/sm8-backend/public/api/',
     'fase1': 'https://software.sm8.com.mx/sm8-backend/public/uploads/archivosClientes/fase1/',
     'fase2': 'https://software.sm8.com.mx/sm8-backend/public/uploads/archivosClientes/fase2/',
     'contratos': 'https://software.sm8.com.mx/sm8-backend/public/uploads/archivosClientes/contratos/',
     'imagenesTickets': 'https://software.sm8.com.mx/software.sm8.com.mx/oft.ddns.net/sm8-backend/public/uploads/imgTickets/',
     'imgComentariosTickets': 'https://software.sm8.com.mx/sm8-backend/public/uploads/imgComentariosTickets/',
     'imagenesPerfil': 'https://software.sm8.com.mx/sm8-backend/public/uploads/imagenesPerfil/',
     'notificaciones': 'http://sm8-betasoft.ddns.net:5000',
    // Urls para local

    // 'url': 'http://localhost:8000/api/',
    // 'fase1': 'http://localhost:8000/uploads/archivosClientes/fase1/',
    // 'fase2': 'http://localhost:8000/uploads/archivosClientes/fase2/',
    // 'contratos': 'http://localhost:8000/uploads/archivosClientes/contratos/',
    // 'imagenesTickets': 'http://localhost:8000/uploads/imgTickets/',
    // 'imagenesPerfil': 'http://localhost:8000/uploads/imagenesPerfil/',
    // 'notificaciones': 'http://sm8-betasoft.ddns.net:3000',// 

    'login': 'login_check',
    'user': {
        'clientes': 'clientes',
        'crearCliente': 'nuevocliente',
        'sucursales': 'sucursales',
        'cancelar': 'cancelar',
        'almacenes': 'almacenes',
        'inventario': 'inventario',
        'usuario': 'usuario',
        'usuarios': 'usuarios',
        'usuarioMenu' : 'dashboard/menu',
        'permisosFuncionalidad': 'dashboard/funciones',
        'documentos': 'documentos/',
        'categorias': 'categorias',
        'productos': 'productos',
        'crearProducto': 'addproducto',
        'agregarComentario': 'addcomentario',
        'agregar': 'agregar',
        'autorizar': 'autorizar',
        'editar': 'edit',
        'detalles': 'detalles',
        'traspasos': 'traspasos',
        'listar': 'listar',
        'solicitud': 'solicitud',
        'solicitudes': 'solicitudes',
        'autorizacion': 'autorizacion',
        'gerente': 'gerente',
        'supervisor': 'supervisor',
        'notificaciones': 'dashboard/notificaciones',
        'contratos': 'contratos',
        'contrato': 'contrato',
        'preautorizar': 'preautorizar',
        'crear': 'crear',
        'garantias': 'garantias',
        'abastecimientos': 'abastecimientos',
        'actualizar': 'actualizar',
        'contactos': 'contactos',
        'eliminar': 'eliminar',
        'orden': 'orden',
        'cotizaciones': 'cotizaciones',
        'cotizacion': 'cotizacion',
        'material': 'material',
        'existencias': 'existencias',
        'generar': 'generar',
        'guardar': 'guardar',
        'apoyos': 'apoyos',
        'contabilidad': 'contabilidad',
        'lista': 'lista',
        'precios': 'precios',
        'aceptar': 'aceptar',
        'rechazar': 'rechazar',
        'descuento': 'descuento',
        'comentario': 'comentario',
        'sindocs': 'sindocs',
        'aceptada': 'aceptada',
        'ot': 'ot',
        'cambio': 'cambio',
        'tickets': 'tickets',
        'soporte': 'soporte',
        'atendiendo': 'atendiendo',
        'resuelto': 'resuelto',
        'evaluar': 'evaluar',
        'imagenes': 'imagenes',
        'subir': 'subir',
        'stock': 'stock',
        'ordenes': 'ordenes',
        'comentar': 'comentar',
        'entradas': 'entradas',
        'salidas': 'salidas',
        'reservado': 'reservado',
        'obra': 'obra',
        'indicadores': 'indicadores',
        'controlInterno': 'controlInterno',
        'movimientos': 'movimientos',
        'espera': 'espera',
        'asignacion': 'asignacion',
        'folios': 'folios',
        'resguardo': 'resguardo',
        'mensajes': {
            'enviar': 'mensajes/enviar',
            'obtener': 'mensajes/obtener',
            'visto': 'mensajes/visto'
        },
        'solicitados': 'solicitados',
        'solicitado': 'solicitado',
        'enviado': 'enviado',
        'respuesta': 'respuesta',
        'fisico': 'fisico',
        'archivos': 'archivos',
        'guarda': 'guarda',
        'cantidad': 'cantidad',
        'aceptado': 'aceptado',
        'sucursal': 'sucursal',
        'informe': 'informe'
    },

};
export const FORMS: any = {
    'login': {
        'title': 'Member Login',
        'button': 'Iniciar Sesión',
        'required': 'El campo es requerido',
        'username': {
            'placeholder': 'Usuario'
        },
        'password': {
            'placeholder': 'Contraseña'
        },
        'error': {
            'badCredentials' : 'Usuario o Constraseña Erróneos',
        }
    },
    'crearCliente': {
        'required': '* El campo es requerido',
        'button': 'Crear Cliente',
        'buttonAuth': 'Autorizar Cliente',
        'rfc': {
            'titulo': 'RFC del Cliente *',
            'placeholder': 'SMS1505...',
            'minlength': 'El campo debe tener como mínimo 10 carácteres',
            'maxlength': 'El campo debe tener como máximo 12 carácteres'
        },
        'nombre': {
            'titulo': 'Nombre',
            'placeholder': 'Nombre'
        },
        'paterno': {
            'titulo': 'Apellido paterno',
            'placeholder': 'Apellido paterno'
        },
        'materno': {
            'titulo': 'Apellido Materno',
            'placeholder': 'Apellido Materno'
        },
        'razonSocial': {
            'titulo': 'Razón Social *',
            'placeholder': 'SISTEMAS MULTIDIRECCIONALES ...'
        },
        'sucursal': {
            'titulo': 'Sucursal *',
            'placeholder': 'Seleccionar'
        },
        'calle': {
            'titulo': 'Calle',
            'placeholder': 'Domicilio Fiscal'
        },
        'noext': {
            'titulo': 'No. Exterior',
            'placeholder': '#'
        },
        'noint': {
            'titulo': 'No. Interior',
            'placeholder': '#'
        },
        'colonia': {
            'titulo': 'Colonia',
            'placeholder': 'Domicilio Fiscal'
        },
        'delegacion': {
            'titulo': 'Delegación o Municipio',
            'placeholder': 'Domicilio Fiscal'
        },
        'codigopostal': {
            'titulo': 'Código Postal',
            'placeholder': 'Domicilio Fiscal'
        },
        'telefono': {
            'titulo': 'Teléfono',
            'placeholder': 'Teléfono'
        },
        'celular': {
            'titulo': 'Celular',
            'placeholder': 'Celular'
        },
        'email': {
            'titulo': 'Email',
            'placeholder': 'ejemplo@ejemplo.com'
        },
        'domicilioCliente': 'Domicilio Particular',
        // Documentos requeridos Primer Paso
        'ine': {
            'titulo': 'INE',
        },
        'sat': {
            'titulo': 'SAT',
        },
        'buro': {
            'titulo': 'Buró de Crédito',
        },
        'acta': {
            'titulo': 'Acta Constitutiva',
        },
        'poder': {
            'titulo': 'Poder Notarial',
        },
        'depositoGarantia': {
            'titulo': 'Deposito en garantia (Minimo por $4000.00)'
        },
        'domicilio': {
            'titulo': 'Comprobante de Domicilio (no mayor a 3 meses de antiguedad)'
        },
        'aviso_privacidad': {
            'titulo': 'Aviso de Privacidad',
        },
        'caratula_bancaria': {
            'titulo': 'Carátula bancaría',
        },
        // Documentos Requeridos Segundo Paso
        'contrato': {
            'titulo': 'Contrato',
        },
        'factura': {
            'titulo': 'Factura',
        },
        'pagare': {
            'titulo': 'Pagaré',
        },
        'ordenTrabajo': {
            'titulo': 'Orden de Trabajo',
        },
        'comprobantePago': {
            'titulo': 'Comprobante de Pago',
        },
        'avalIne': {
            'titulo': 'INE del Aval'
        },
        'avalDomicilio': {
            'titulo': 'Comprobante de domicilio del Aval',
        },
        'otro1': {
            'titulo': 'Otro documento 1 (Opcional)',
        },
        'otro2': {
            'titulo': 'Otro documento 2 (Opcional)',
        },
        // Comentarios
        'comentario': {
            'titulo': 'Comentario',
            'placeholder': 'Escribir ...'
        },
        'comentarioArchivos': {
            'boton': 'Comentar',
            'placeholder': 'Comentario ...'
        }

    },
    'crearProducto': {
        'sku': 'SKU *',
        'descripcion': 'Descripción *',
        'categoria': 'Categoría *',
        'sucursal': 'Sucursal',
        'precioventa': '* Precio Venta $ ',
        'precioventamin': '* Precio Venta Mínimo $ ',
        'preciorenta': '* Precio Renta $ ',
        'preciorentamin': '* Precio Renta Mínimo $ ',
        'peso': '* Peso Kg. ',
        'agreagarAlmacen': 'Agregar a Almacén'
    }

};

export const PAGE: any = {
    'dashboard': '/dashboard/',
    'listarClientes': {
        'verClienteBtn': 'Ver Cliente',
        'editarClienteBtn': 'Editar Cliente'
    },
    'verCliente': {
        'verDocumento': 'Ver Documento',
        'verComentario': 'Comentarios',
        'autorizarCliente': 'Autorizar Cliente',
        'autorizarDocumento': 'Autorizar Documento',
        'rechazarDocumento': 'Rechazar Documento',
        'autorizarContrato': 'Autorizar',
        'rechazarContrato': 'Rechazar',
        'preautorizar': 'Pre-autorizar',
        'descargarDocumento': 'Descargar Documento',
        'escribirMensaje': 'Escribe tu mensaje aqui...'
    },
    'verProducto': {
        'faltaSKUAlmacen': 'Falta el SKU del Producto o Almacén o Cantidad',
        'productoAgregado': 'Se agregó el producto'
    }
};
// Comentarios reusables
export const GENERALES: any = {
    'cargandoMenu': 'Cargando Menu...',
    'queDeseaHacer': '¿Qué Desea Hacer?',
    'algoOcurrio': 'Revisa tu conexión',
    'editar': 'Editar',
    'ver': 'Ver',
    'borrar': 'Borrar',
    'noTienePermisos': 'Lo sentimos pero no cuenta con los permisos para ver esta sección',
    'logOut': ' Cerrar Sesion'
};
// Codigo de funcionalidad con rutas
export const CODFUNC = [
    { codFunc: 'CLIVER', nombre: 'Cliente', url: 'listarClientes', icon: 'mdi-account-box'},
    { codFunc: 'CPAVER', nombre: 'Clientes Pre-autorizados', url: 'listarClientesPreautorizados', icon: 'mdi-account-minus' },
    { codFunc: 'COTVER', nombre: 'Cotizaciones', url: 'cotizaciones', icon: 'mdi-pen'},
    { codFunc: 'ORDVER', nombre: 'Orden de Trabajo', url: 'listarOrdenTrabajo', icon: 'mdi-factory'},
    { codFunc: 'SLEVER', nombre: 'Solicitudes de existencias', url: 'listarSolicitudesExistencias', icon: 'mdi-format-list-bulleted'},
    { codFunc: 'APOVER', nombre: 'Apoyos almacén', url: 'listarSolicitudesApoyo', icon: 'mdi-rotate-left-variant' },
    { codFunc: 'COMVER', nombre: 'Cálculo de comisiones', url: 'comisiones', icon: 'mdi-calculator' },
    { codFunc: 'ORPVER', nombre: 'Ordenes pendientes', url: 'listarClienteOrdenPendiente', icon: 'mdi-content-paste' },
    { codFunc: 'ICIVER', nombre: 'Indicador', url: 'indicador', icon: 'mdi-format-italic' },
    { codFunc: 'MALVER', nombre: 'Menú Almacén', url: 'menuAlmacen', icon: 'mdi-grid' }
    // { codFunc: 'LISEXIS'}
];

export const PETICION: any = {
    'error': {
        'e401': 'Sesión Expirada. Inicie sesión nuevamente',
    }
};
// Contabilidad-comisiones
export const SUCURSALES: any = [
    {
        codSuc: 'GDL',
        codSeguridad: '01x',
        nombre: 'Guadalajara',
        metaTope: '$1,950,000.00',
        metadesucursal: '1950000.00',
        gerente1: 'Salvador Ibañez Delgadillo',
        gerente2: 'Oscar Edscel Coronilla Castañeda',
        gerente3: 'Cristian González',
        gerente4: '',
        porcentaje1: '50%',
        porcentaje2: '20%',
        porcentaje3: '5%',
        porcentaje4: '',
        pdecimal1: '.50',
        pdecimal2: '.20',
        pdecimal3: '.05',
        pdecimal4: ''
    },
    {
        codSuc: 'VJO',
        codSeguridad: '01x',
        nombre: 'Vallejo',
        metaTope: '$2,150,000.00',
        metadesucursal: '2150000.00',
        gerente1: 'Everardo Villegas Lopez',
        gerente2: 'José Luis Ramirez Guzman',
        gerente3: 'Luis Enrique Rodriguez',
        gerente4: '',
        porcentaje1: '26.67%',
        porcentaje2: '26.67%',
        porcentaje3: '26.67%',
        porcentaje4: '',
        pdecimal1: '.2667',
        pdecimal2: '.2667',
        pdecimal3: '.2667',
        pdecimal4: ''
    },
    {
        codSuc: 'MON',
        codSeguridad: '01x',
        nombre: 'Monterrey',
        metaTope: '$1,370,000.00',
        metadesucursal: '1370000.00',
        gerente1: 'Angélica Patricia Treviño',
        gerente2: 'Obed Arturo Salmerón',
        gerente3: 'Griselda Paola Ruiz Quintero',
        gerente4: '',
        porcentaje1: '33%',
        porcentaje2: '33%',
        porcentaje3: '33%',
        porcentaje4: '',
        pdecimal1: '0.33',
        pdecimal2: '0.33',
        pdecimal3: '0.33',
        pdecimal4: ''
    },
    {
        codSuc: 'CAB',
        codSeguridad: '01x',
        nombre: 'Los Cabos',
        metaTope: '$1,500,000.00',
        metadesucursal: '1500000.00',
        gerente1: 'Rocio Gastelum Cortez',
        gerente2: '',
        gerente3: '',
        gerente4: '',
        porcentaje1: '100%',
        porcentaje2: '',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '1',
        pdecimal2: '',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'CUL',
        codSeguridad: '01x',
        nombre: 'Culiacán',
        metaTope: '$655,000.00',
        metadesucursal: '655000.00',
        gerente1: 'Adriana Marisol Meza González',
        gerente2: 'Sergio Bayliss Martinez',
        gerente3: 'Gustavo Ortoño Montes',
        gerente4: 'Beatriz Adriana Hernandez Retamoza',
        porcentaje1: '20%',
        porcentaje2: '35%',
        porcentaje3: '35%',
        porcentaje4: '10%',
        pdecimal1: '.20',
        pdecimal2: '.35',
        pdecimal3: '.35',
        pdecimal4: '.10'
    },
    {
        codSuc: 'QUE',
        codSeguridad: '01x',
        nombre: 'Querétaro',
        metaTope: '$1,000,000.00',
        metadesucursal: '1000000.00',
        gerente1: 'Rosaura González Godoy',
        gerente2: 'Alan Rasiel Rodriguez Zambrano',
        gerente3: 'Jaime Eduardo Acosta',
        gerente4: '',
        porcentaje1: '44%',
        porcentaje2: '31%',
        porcentaje3: '25%',
        porcentaje4: '',
        pdecimal1: '.44',
        pdecimal2: '.31',
        pdecimal3: '.25',
        pdecimal4: ''
    },
    {
        codSuc: 'PUE',
        codSeguridad: '01x',
        nombre: 'Puebla',
        metaTope: '$920,000.00',
        metadesucursal: '920000.00',
        gerente1: 'Nestor Flores Bernardino',
        gerente2: '',
        gerente3: '',
        gerente4: '',
        porcentaje1: '20%',
        porcentaje2: '',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '.20',
        pdecimal2: '',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'COA',
        codSeguridad: '01x',
        nombre: 'Coatzacoalcos',
        metaTope: '$1,000,000.00',
        metadesucursal: '1000000.00',
        gerente1: 'Karina Peña Sanchez',
        gerente2: 'Ramón Cruz Culebro',
        gerente3: '',
        gerente4: '',
        porcentaje1: '50%',
        porcentaje2: '50%',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '.50',
        pdecimal2: '.50',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'MAZ',
        codSeguridad: '01x',
        nombre: 'Mazatlán',
        metaTope: '$550,000.00',
        metadesucursal: '550000.00',
        gerente1: 'Itzayana Viera Estrada',
        gerente2: 'Gilberto Amhed De La Vega',
        gerente3: '',
        gerente4: '',
        porcentaje1: '50%',
        porcentaje2: '30%',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '.50',
        pdecimal2: '.30',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'TIJ',
        codSeguridad: '01x',
        nombre: 'Tijuana',
        metaTope: '$750,000.00',
        metadesucursal: '750000.00',
        gerente1: 'Rodolfo Saul Valencia Cazares',
        gerente2: 'Rochin Parra Angel Paul',
        gerente3: '',
        gerente4: '',
        porcentaje1: '50%',
        porcentaje2: '40%',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '.50',
        pdecimal2: '.40',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'CUE',
        codSeguridad: '01x',
        nombre: 'Cuernavaca',
        metaTope: '$550,000.00',
        metadesucursal: '550000.00',
        gerente1: 'Paula Indira Gomez Monroy',
        gerente2: '',
        gerente3: '',
        gerente4: '',
        porcentaje1: '80%',
        porcentaje2: '',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '.80',
        pdecimal2: '',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'CAN',
        codSeguridad: '01x',
        nombre: 'Cancún',
        metaTope: '$530,000.00',
        metadesucursal: '530000.00',
        gerente1: 'Graciela Martinez Salvador',
        gerente2: 'Angélica Pacheco Jose',
        gerente3: 'Francisco Lopez Romay',
        gerente4: '',
        porcentaje1: '25%',
        porcentaje2: '25%',
        porcentaje3: '25%',
        porcentaje4: '',
        pdecimal1: '.25',
        pdecimal2: '.25',
        pdecimal3: '.25',
        pdecimal4: ''
    },
    {
        codSuc: 'TUX',
        codSeguridad: '01x',
        nombre: 'Tuxtla',
        metaTope: '$330,000.00',
        metadesucursal: '330000.00',
        gerente1: 'María Elena Muñoz Ruiz',
        gerente2: 'Gustavo Álvares Zebuda',
        gerente3: '',
        gerente4: '',
        porcentaje1: '20%',
        porcentaje2: '80%',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '.20',
        pdecimal2: '.80',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'TLA',
        codSeguridad: '01x',
        nombre: 'Tlaquepaque',
        metaTope: '$750,000.00',
        metadesucursal: '750000.00',
        gerente1: 'Carlos Ricardo Padilla Mendez',
        gerente2: '',
        gerente3: '',
        gerente4: '',
        porcentaje1: '40%',
        porcentaje2: '',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '0.40',
        pdecimal2: '',
        pdecimal3: '',
        pdecimal4: ''
        // pdecimal: '0.3333',
    },
    {
        codSuc: 'TOL',
        codSeguridad: '01x',
        nombre: 'Toluca',
        metaTope: '$1,000,000.00',
        metadesucursal: '1000000.00',
        gerente1: 'Alfonso Miguel Salazar',
        gerente2: 'José Juan Rafael Secundino',
        gerente3: 'Juan Carlos Ortiz Álvarez',
        gerente4: '',
        porcentaje1: '34%',
        porcentaje2: '34%',
        porcentaje3: '12%',
        porcentaje4: '',
        pdecimal1: '.34',
        pdecimal2: '.34',
        pdecimal3: '.12',
        pdecimal4: ''
    },
    {
        codSuc: 'AGU',
        codSeguridad: '01x',
        nombre: 'Aguascalientes',
        metaTope: '$250,000.00',
        metadesucursal: '250000.00',
        gerente1: 'Zuleica Alheli Cardiel Gallegos',
        gerente2: 'José Fernando Jazo González',
        gerente3: '',
        gerente4: '',
        porcentaje1: '50%',
        porcentaje2: '50%',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '.50',
        pdecimal2: '.50',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'PVA',
        codSeguridad: '01x',
        nombre: 'Puerto Vallarta',
        metaTope: '$500,000.00',
        metadesucursal: '500000.00',
        gerente1: 'Yesenia Villa González',
        gerente2: 'Luis Enrique Abunader',
        gerente3: '',
        gerente4: '',
        porcentaje1: '60%',
        porcentaje2: '10%',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '.60',
        pdecimal2: '.10',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'PAZ',
        codSeguridad: '01x',
        nombre: 'La Paz',
        metaTope: '$250,000.00',
        metadesucursal: '250000.00',
        gerente1: 'Imelda Eugenia Adame Nuñez',
        gerente2: '',
        gerente3: '',
        gerente4: '',
        porcentaje1: '100%',
        porcentaje2: '',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '1',
        pdecimal2: '',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'MER',
        codSeguridad: '01x',
        nombre: 'Mérida',
        metaTope: '$250,000.00',
        metadesucursal: '250000.00',
        gerente1: 'Patricio Senties García',
        gerente2: '',
        gerente3: '',
        gerente4: '',
        porcentaje1: '40%',
        porcentaje2: '',
        porcentaje3: '',
        porcentaje4: '',
        pdecimal1: '.40',
        pdecimal2: '',
        pdecimal3: '',
        pdecimal4: ''
    },
    {
        codSuc: 'NAY',
        codSeguridad: '01x',
        nombre: 'Nayarit',
        metaTope: '$100,000.00',
        metadesucursal: '100000.00',
        gerente1: 'Gerente 1',
        gerente2: 'Gerente 2',
        gerente3: 'Gerente 3',
        gerente4: 'Gerente 4',
        porcentaje1: '25%',
        porcentaje2: '25%',
        porcentaje3: '25%',
        porcentaje4: '25%',
        pdecimal1: '.25',
        pdecimal2: '.25',
        pdecimal3: '.25',
        pdecimal4: '.25'
    }
];



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_config/strings.ts